module.exports = "/images/04c011bacfd152dfbc1d8a7c903fe38d.png";